document.addEventListener('DOMContentLoaded', () => {
  initInfiniteScroll();
});

function initInfiniteScroll() {
  const trigger = document.querySelector('#InfiniteScroll');
  const productGrid = document.querySelector('#product-grid');

  if (!trigger || !productGrid) return;

  let loading = false;

  const observer = new IntersectionObserver(
    async (entries) => {
      const entry = entries[0];

      if (!entry.isIntersecting || loading) return;

      loading = true;
      observer.unobserve(trigger);

      try {
        const nextUrl = trigger.dataset.nextUrl;
        if (!nextUrl) return;

        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error('No se pudo cargar la siguiente página');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const nextGrid = doc.querySelector('#product-grid');
        const nextTrigger = doc.querySelector('#InfiniteScroll');

        if (!nextGrid) return;

        const products = Array.from(nextGrid.children);

        products.forEach((product) => {
          productGrid.appendChild(product);
        });

        if (nextTrigger?.dataset.nextUrl) {
          trigger.dataset.nextUrl = nextTrigger.dataset.nextUrl;
          loading = false;
          observer.observe(trigger);
        } else {
          trigger.remove();
        }
      } catch (error) {
        console.error('Infinite scroll:', error);
        loading = false;
      }
    },
    {
      rootMargin: '600px 0px',
      threshold: 0,
    }
  );

  observer.observe(trigger);
}